module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 12 12",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#linkedin",
      toString: function () {
        return this.url;
      }
    }